interface StatsCardProps {
  title: string;
  value: number;
  subtitle: string;
  icon: 'users' | 'calendar' | 'clock' | 'repeat';
}

const iconMap = {
  users: (
    <svg className='h-8 w-8 text-blue-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
      />
    </svg>
  ),
  calendar: (
    <svg className='h-8 w-8 text-green-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
      />
    </svg>
  ),
  clock: (
    <svg className='h-8 w-8 text-orange-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  ),
  repeat: (
    <svg className='h-8 w-8 text-purple-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
      />
    </svg>
  )
};

export function StatsCard({ title, value, subtitle, icon }: StatsCardProps) {
  return (
    <div className='rounded-lg bg-white p-3 shadow-md md:p-6 dark:bg-gray-800'>
      <div className='flex items-center justify-between'>
        <div className='flex-1'>
          <p className='text-xs font-medium text-gray-600 md:text-sm dark:text-gray-400'>{title}</p>
          <p className='mt-1 text-xl font-bold text-gray-800 md:mt-2 md:text-3xl dark:text-white'>
            {value.toLocaleString()}
          </p>
          <p className='mt-0.5 text-xs text-gray-500 md:mt-1 md:text-sm dark:text-gray-400'>
            {subtitle}
          </p>
        </div>
        <div className='flex-shrink-0'>{iconMap[icon]}</div>
      </div>
    </div>
  );
}
